import {Field, FIELD_TYPES, Model} from '../../vue-ocom/schema';

export default Model('job_task', {
  verbose_name: "Job Task",
  verbose_name_plural: "Job Tasks",
  fields: [
    Field('id', {label: 'ID', primary_key: true, readonly: true, hide: false, field_type: FIELD_TYPES.AutoNumber}),

    Field('job', {
      label: "Job",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "Job", ref_display_field: "",
      default: () => {
        return null;
      }
    }),
    Field('truck', {
      label: "Truck",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeTruck", ref_display_field: "name",
      default: () => {
        return null;
      }
    }),
    Field('when', {
      label: "When",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('active_start_date', {
      label: "Active Start Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return new Date();
      }
    }),
    Field('active_end_date', {
      label: "Active End Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('modified_date', {
      label: "Modified Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('created_date', {
      label: "Created Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('trip_number', {
      label: "Trip Number",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return null;
      }
    }),
    Field('task_type', {
      label: "Task Type",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeJobTaskType", ref_display_field: "description",
      default: () => {
        return '';
      }
    }),
    Field('start_time', {
      label: "Start Time",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return '';
      }
    }),
  ]
});
